/**
 * Curse Premium Cart — drawer redirect, checkout, cart.js patch, kupon
 */
(function () {
  'use strict';

  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var giftToggleBound = false;

  function isCartPage() {
    return window.__CURSE_CART_PAGE__ || !!document.getElementById('CursePremiumCart');
  }

  function toggleGiftPanel(forceOpen) {
    var toggle = document.getElementById('cc-cart-gift-toggle');
    var panel = document.getElementById('cc-cart-gift-panel');
    if (!toggle || !panel || toggle.disabled) return;

    var open = typeof forceOpen === 'boolean' ? forceOpen : toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      panel.removeAttribute('hidden');
      panel.classList.add('is-open');
      try {
        window.__curseGiftPanelKeepOpen = true;
      } catch (eK) {}
    } else {
      panel.setAttribute('hidden', '');
      panel.classList.remove('is-open');
      try {
        window.__curseGiftPanelKeepOpen = false;
      } catch (eK2) {}
    }
  }

  window.curseCartReopenGiftPanel = function () {
    if (!isCartPage()) return;
    toggleGiftPanel(true);
  };

  function bindGiftToggle() {
    if (giftToggleBound) return;
    giftToggleBound = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!isCartPage()) return;
        var toggle = e.target.closest('#cc-cart-gift-toggle');
        if (!toggle || toggle.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        toggleGiftPanel();
      },
      true
    );
  }

  function bindDrawerCheckoutRedirect() {
    document.addEventListener(
      'click',
      function (e) {
        if (window.__CURSE_CART_PAGE__) return;
        var btn = e.target.closest('#CartDrawer-Checkout, .cart-drawer .cart__checkout-button');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var cartUrl =
          btn.getAttribute('data-cart-url') ||
          btn.getAttribute('data-shipping-url') ||
          (window.routes && window.routes.cart_url) ||
          '/cart';
        if (typeof window.hideCurseLoading === 'function') window.hideCurseLoading();
        window.location.assign(cartUrl);
      },
      true
    );
  }

  function patchCartItems() {
    if (!isCartPage() || typeof CartItems === 'undefined') return;

    var proto = CartItems.prototype;
    if (proto.__cursePremiumPatched) return;
    proto.__cursePremiumPatched = true;

    var origValidate = proto.validateQuantity;
    proto.validateQuantity = function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('quantity__input')) {
        return origValidate.call(this, event);
      }
      var step = parseInt(input.step, 10) || 1;
      var min = parseInt(input.dataset.min, 10) || 1;
      var val = parseInt(input.value, 10);
      if (Number.isFinite(val) && step > 1 && val % step !== 0) {
        var snapped = Math.max(min, Math.round(val / step) * step);
        input.value = String(snapped);
      }
      input.setCustomValidity('');
      return origValidate.call(this, event);
    };

    proto.getSectionsToRender = function () {
      var itemsEl = document.getElementById('main-cart-items');
      var sectionId = itemsEl && itemsEl.dataset.id;
      if (!sectionId) {
        return [
          { id: 'main-cart-items', section: 'main-cart-items', selector: '.js-contents' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
        ];
      }
      var list = [
        { id: 'main-cart-items', section: sectionId, selector: '.js-contents' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      ];
      if (document.getElementById('cc-cart-summary')) {
        list.splice(1, 0, { id: 'cc-cart-summary', section: sectionId, selector: '.js-contents-summary' });
      }
      if (document.getElementById('cc-cart-promos')) {
        list.splice(document.getElementById('cc-cart-summary') ? 2 : 1, 0, {
          id: 'cc-cart-promos',
          section: sectionId,
          selector: '.js-contents-promos',
        });
      }
      return list;
    };

    var origGetSectionInnerHTML = proto.getSectionInnerHTML;
    proto.getSectionInnerHTML = function (html, selector) {
      if (!html) return '';
      try {
        return origGetSectionInnerHTML.call(this, html, selector);
      } catch (err) {
        return '';
      }
    };
  }

  function bindCartPageDelegation() {
    if (!isCartPage()) return;

    document.addEventListener('click', function (e) {
      if (!document.getElementById('CursePremiumCart')) return;

      var checkoutBtn = e.target.closest('#checkout');
      if (checkoutBtn) {
        e.preventDefault();
        var shippingUrl = checkoutBtn.getAttribute('data-shipping-url') || '/cart?view=kargo';
        window.location.href = shippingUrl;
        return;
      }

      var couponBtn = e.target.closest('#cc-coupon-apply');
      if (couponBtn) {
        var input = document.getElementById('cc-discount-input');
        var code = input && (input.value || '').trim();
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CART_URL);
        }
        return;
      }

      var couponToggle = e.target.closest('#cc-coupon-toggle');
      if (couponToggle) {
        var box = document.getElementById('cc-coupon-box');
        if (!box) return;
        var open = couponToggle.getAttribute('aria-expanded') === 'true';
        couponToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        box.hidden = open;
      }
    });
  }

  function lockGiftQtyRows() {
    var giftIds = ['67958040363374', '53366561112430', '53366569173358', '53262353170798'];
    document.querySelectorAll('.cc-cart-row').forEach(function (row) {
      var isGift =
        row.classList.contains('cc-cart-row--gift') ||
        !!row.querySelector('.cc-cart-row__gift-note') ||
        !!row.querySelector('.cc-cart-row__gift-badge');
      if (!isGift) {
        var input = row.querySelector('.quantity__input[data-quantity-variant-id]');
        if (input && giftIds.indexOf(String(input.getAttribute('data-quantity-variant-id'))) !== -1) {
          isGift = true;
        }
      }
      if (!isGift) return;
      row.classList.add('cc-cart-row--gift');
      var qtyCol = row.querySelector('.cc-cart-row__qty');
      if (!qtyCol) return;
      if (!qtyCol.querySelector('.cc-cart-row__qty-fixed')) {
        qtyCol.innerHTML = '<span class="cc-cart-row__qty-fixed" aria-label="Adet: 1">1</span>';
      }
    });
  }

  function bindGiftPanelPersist() {
    document.addEventListener('cart:updated', function () {
      if (!isCartPage()) return;
      lockGiftQtyRows();
      try {
        if (window.__curseGiftPanelKeepOpen && typeof window.curseCartReopenGiftPanel === 'function') {
          requestAnimationFrame(function () {
            window.curseCartReopenGiftPanel();
          });
        }
      } catch (eP) {}
    });
  }

  function redirectLegacyKargoParam() {
    try {
      var path = window.location.pathname || '';
      var search = window.location.search || '';
      if (path.indexOf('/cart') === -1) return;
      if (search.indexOf('adim=kargo') === -1) return;
      if (search.indexOf('view=kargo') !== -1) return;
      window.location.replace('/cart?view=kargo');
    } catch (eR) {}
  }

  function init() {
    if (window.__curseCartPageInit) return;
    window.__curseCartPageInit = true;
    redirectLegacyKargoParam();
    patchCartItems();
    bindDrawerCheckoutRedirect();
    bindCartPageDelegation();
    bindGiftToggle();
    bindGiftPanelPersist();
    lockGiftQtyRows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
